export const SET_SPS = 'associateRatesToReference/SET_SPS';
export const SET_WAITING = 'associateRatesToReference/SET_WAITING';
